<template>
  <v-app class="app-tabela">
    <div class="box" style="margin-top: 0px">
      <v-card class="tabela">
        <v-card-title>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Nome"
            class="input-bottom"
            single-line
            hide-details
          ></v-text-field>
        </v-card-title>
        <v-data-table
          @pagination="getPagination"
          :page="currentPage"
          :footer-props="{
            itemsPerPageText: '',
            'items-per-page-options': [10],
            'disable-items-per-page': true,
          }"
          :loading="loading"
          loading-text="Carregando, Por favor espere"
          :headers="headers"
          :item-class="row_classes"
          :items="indexedItems"
          :search="search"
          :single-expand="true"
          :expanded.sync="expanded"
          item-key="id"
          show-expand
          class="elevation-1"
        >
          <!-- <template #footer.prepend>
          <v-spacer />
        </template> -->
          <template v-slot:[`footer.page-text`]="items">
            <div class="info-table-item tabela-esus-pec">
              <FonteEsusPecGlobal
                :texto="texto_esus_pec"
                :data="data_esus_pec"
              />
            </div>
            <span class="paginacao"
              >{{ items.pageStart }} - {{ items.pageStop }} de
              {{ items.itemsLength }} pessoas</span
            >
          </template>
          <template v-slot:header.micro_area="{ header }">
            {{ header.text }}
            <span
              v-b-tooltip.hover.right
              title="Microárea do ACS"
              class="icon-tooltip"
            >
              <i class="icofont-info-circle"></i>
            </span>
          </template>
          <template v-slot:item.id="{ item }">
            {{ item.id == null ? item.nu_cpf_cns : item.id }}
          </template>

          <template v-slot:item.dt_nascimento="{ item }">
            {{ formatDate(item.dt_nascimento) }}
          </template>
          <template v-slot:item.dt_atendimento="{ item }">
            {{
              item.dt_atendimento !== null
                ? formatDate(item.dt_atendimento)
                : 'Auto referido'
            }}
          </template>
          <template v-slot:item.dt_pa_2="{ item }">
            {{ formatDate(item.dt_pa_2) }}
          </template>

          <template v-slot:progress>
            <v-progress-linear
              color="blue"
              :height="10"
              indeterminate
            ></v-progress-linear>
          </template>
          <template v-slot:no-data>
            <div class="alert alert-info mb-0">
              <b>Nenhuma informação encontrada. Selecione outro filtro.</b>
            </div>
          </template>
          <template v-slot:no-results style="padding: 0px">
            <div class="alert alert-info mb-0">
              <b>Nenhuma informação encontrada. Selecione outro filtro.</b>
            </div>
          </template>
          <template v-slot:expanded-item="{ headers, item }">
            <td colspan="8">
              <table class="table table-interna table-interna-pre-natal">
                <thead>
                  <tr>
                    <th>Doc</th>
                    <th>Hipertensão</th>
                    <th>PA</th>
                    <th>Diabetes</th>
                    <th>S.Hemoglobina</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      <div class="d-block mb-2">
                        <strong>CPF </strong>
                        <show-hide-field :value="item.nu_cpf"></show-hide-field>
                        <br />
                        <strong>CNS </strong>
                        <show-hide-field :value="item.nu_cns"></show-hide-field>
                      </div>
                    </td>
                    <td>
                      <div class="d-block mb-2">
                        {{
                          item.atendimento_hip !== null
                            ? formatDate(item.atendimento_hip)
                            : 'Auto referido'
                        }}
                      </div>
                    </td>
                    <td>
                      <div class="d-block mb-2">
                        {{ formatDate(item.dt_pa_2) }}
                      </div>
                    </td>
                    <td>
                      <div class="d-block mb-2">
                        {{
                          item.atendimento_dia !== null
                            ? formatDate(item.atendimento_dia)
                            : 'Auto referido'
                        }}
                      </div>
                    </td>
                    <td>
                      <div class="d-block mb-2">
                        {{ formatDate(item.dt_ultima_hemoglobina) }}
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>
          </template>
        </v-data-table>
      </v-card>
    </div>
  </v-app>
</template>

<script>
import * as Functions from './functions'
import utils from '@/mixins/utils.js'
import ShowHideField from '@/components/utils/ShowHideField.vue'

export default {
  name: 'TabelaCadastrosVuetfy',
  components: {
    ShowHideField,
  },
  props: {
    cadastros: {
      type: Array,
      default: () => {},
    },
    data_secretaria_de_saude: {
      type: String,
      default: '',
    },
    loading: {
      type: Boolean,
      default: false,
    },
    texto_esus_pec: {
      type: String,
      default: '',
    },
    data_esus_pec: {
      type: String,
      default: '',
    },
  },
  mixins: [utils],
  data() {
    return {
      currentPage: 1,
      info_1_pa: '',
      info_2_pa: '',
      expanded: [],
      enabled: null,
      search: '',
      headers: [
        {
          text: 'Nome',
          align: 'start',
          filterable: true,
          value: 'no_cidadao',
        },
        {
          text: 'Nascimento',
          align: 'start',
          filterable: false,
          value: 'dt_nascimento',
        },
        {
          text: 'Mãe',
          align: 'start',
          filterable: false,
          value: 'no_mae',
        },
        {
          text: 'MA',
          align: 'start',
          filterable: false,
          value: 'micro_area',
        },
        { text: '', value: 'data-table-expand' },
      ],
    }
  },
  computed: {
    indexedItems() {
      return this.cadastros.map((item, index) => ({
        id: index,
        ...item,
      }))
    },
  },
  mounted() {
    this.infoDtpa()
  },
  watch: {
    cadastros: {
      handler(newValue, oldValue) {
        this.currentPage = 1
      },
      deep: true,
    },
    search: {
      handler(newValue) {
        if (newValue) {
          this.$emit('filterSearch', { filter: this.filterItems(newValue) })
          return
        }
        this.$emit('filterSearch', { filter: false })
      },
      deep: true,
    },
  },
  methods: {
    filterItems(search) {
      const searchTerms = search.toLowerCase().trim()
      const filteredItems = this.cadastros.filter((item) => {
        for (const header of this.headers) {
          if (header.filterable && item.hasOwnProperty(header.value)) {
            const itemValue = String(item[header.value]).toLowerCase()
            if (itemValue.includes(searchTerms)) {
              return true
            }
          }
        }
        return false
      })
      return filteredItems
    },
    getPagination(options) {
      this.currentPage = options.page
    },
    row_classes(item) {
      return `table-row-color-${this.printTableRow(item)}`
    },
    infoDtpa() {
      let quadrimestre_atual = this.retornaQuadrimestreAtual()
      let data_atual = new Date()
      let mes_atual = parseInt(data_atual.getMonth() + 1) // janeiro=0
      let ano_atual = parseInt(data_atual.getFullYear())
      if (quadrimestre_atual.indexOf('Q1') > -1) {
        this.info_1_pa = `Semestre maio de ${ano_atual - 1} a outubro de ${
          ano_atual - 1
        }`
        this.info_2_pa = `Semestre novembro de ${
          ano_atual - 1
        } a abril de ${ano_atual}`
      }
      if (quadrimestre_atual.indexOf('Q2') > -1) {
        this.info_1_pa = `Semestre setembro de ${
          ano_atual - 1
        } a fevereiro de ${ano_atual}`
        this.info_2_pa = `Semestre março de ${ano_atual} a agosto de ${ano_atual}`
      }
      if (quadrimestre_atual.indexOf('Q3') > -1) {
        this.info_1_pa = `Semestre janeiro a junho de ${ano_atual}`
        this.info_2_pa = `Semestre julho a dezembro de ${ano_atual}`
      }
    },

    retornaQuadrimestreAtual() {
      let quadrimestre_atual = ''
      let data_atual = new Date()
      let mes_atual = parseInt(data_atual.getMonth() + 1) // janeiro=0
      let ano_atual = parseInt(data_atual.getFullYear())
      if (mes_atual >= 1 && mes_atual <= 4) {
        quadrimestre_atual = ano_atual - 1 + ' Q1'
      } else if (mes_atual >= 5 && mes_atual <= 8) {
        quadrimestre_atual = ano_atual - 1 + ' Q2'
      } else if (mes_atual >= 9 && mes_atual <= 12) {
        quadrimestre_atual = ano_atual + ' Q3'
      } else {
        quadrimestre_atual = ''
      }
      return quadrimestre_atual
    },

    // Muda a cor dos textos de cada linha da tabela
    printTableRow(item) {
      return Functions.printTableRow(item)
    },
  },
}
</script>
<style scoped lang="scss">
.table.table-interna-pre-natal {
  tbody {
    tr {
      td {
        vertical-align: text-top;
      }
    }
  }
}
.table-interna {
  width: 100%;
  margin: 25px auto;
  display: table;
  thead {
    tr {
      background-color: #f7f7f7;
      th {
      }
    }
  }
  tbody {
    tr {
      margin-bottom: 10px;
      td {
        span {
          font-size: 13px !important;
          color: #000 !important;
        }
      }
      td {
        ul {
          list-style-type: disc;
        }
      }
    }
  }
}

.tabela .input-bottom {
  color: #0fafd7;
}

.tabela .table-row-color-green {
  color: green !important;
}
.tabela .table-row-color-red {
  color: red !important;
}
.tabela
  .theme--light.v-data-table
  > .v-data-table__wrapper
  > table
  > thead
  > tr:last-child
  > th {
  font-size: 16px;
}
.tabela .v-icon.v-icon {
  opacity: 1;
}
.tabela .v-data-footer {
  margin-top: 15px;
  margin-bottom: 15px;
  float: right;
  border-top: unset !important;
}
.tabela .v-data-table__empty-wrapper {
  background: #d1ecf1;
  padding: 0px;
  border: unset;
}
.tabela .alert {
  border-radius: unset;
  border: unset;
  border-color: unset;
}
.app-tabela {
  .v-application--wrap {
    margin-bottom: unset;
    min-height: unset;
  }
}
.tabela .tabela-esus-pec {
  font-size: 16px !important;
  position: absolute;
  left: 15px;
  @media screen and (max-width: 600px) {
    position: unset;
    left: unset;
  }
}

.tabela .v-data-footer {
  @media screen and (max-width: 600px) {
    width: 100%;
    display: flex;
    justify-content: center;
  }
}
.tabela
  .theme--light.v-data-table
  > .v-data-table__wrapper
  > table
  > tbody
  > tr:not(:last-child)
  > td:not(.v-data-table__mobile-row),
.theme--light.v-data-table
  > .v-data-table__wrapper
  > table
  > tbody
  > tr:not(:last-child)
  > th:not(.v-data-table__mobile-row) {
  border-bottom: unset;
}
</style>
